import { createGlobalStyle } from 'styled-components';

export const darkTheme = { styledAntLayout: '#16262B' };
export const lightTheme = { styledAntLayout: '#FFFFFF' };

export const GlobalStyle = createGlobalStyle`

@font-face {
  font-family: 'TT Hoves';
  src: url(data:application/font-woff2;charset=utf-8;base64,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) format('woff2'),
       url(data:application/font-woff;charset=utf-8;base64,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) format('woff');
  font-weight: normal;
  font-style: normal;

}

.App {
  text-align: center;
}

.ant-layout {
  background: ${({ theme }) => theme.styledAntLayout};
  font-family: TT Hoves;
  overflow: hidden;
  justify-content: center;
}

a {
  color: #3B98E6;
}

body {
  color: #b1c4d0
}

.totalScoreCellRed {
  font-family: TT Hoves;
  font-style: normal;
  font-size: 25px;
  line-height: 35px;
  color: #ffffff;
  background: linear-gradient(65.07deg, #ff3129 0%, #ff6762 100%) !important;
  /*important used because sorting creates a new class (td.ant-table-column-sort) with a different color in ant and I want to retain this color */
  box-shadow: 0px 2px 8px rgba(132, 157, 171, 0.15);
  text-align: center;
}

.totalScoreCellYellow {
  font-family: TT Hoves;
  font-style: normal;
  font-size: 25px;
  line-height: 35px;
  color: #ffffff;
  background: linear-gradient(
    71.54deg,
    #f3be00 3.75%,
    #ffe600 97.3%
  ) !important;
  /*important used because sorting creates a new class (td.ant-table-column-sort) with a different color in ant and I want to retain this color */
  box-shadow: 0px 2px 8px rgba(132, 157, 171, 0.15);
  border-radius: 0px 6px 6px 0px;
  text-align: center;
}

.totalScoreCellGreen {
  font-family: TT Hoves;
  font-style: normal;
  font-size: 25px;
  line-height: 35px;
  color: #ffffff;
  //background: linear-gradient(65.07deg, #1f9110 0%, #37b871 100%) !important;
  /*important used because sorting creates a new class (td.ant-table-column-sort) with a different color in ant and I want to retain this color */
  box-shadow: 0px 2px 8px rgba(132, 157, 171, 0.15);
  border-radius: 0px 6px 6px 0px;
  text-align: center;
}

.footer {
  height: 1px;
  background: #16262B;
  color: #b0c1c7;
}

.footer_left {
  float: left;
  font-family: TT Hoves;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 15px;
}

.footer_right {
  float: right;
  font-family: TT Hoves;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 15px;
}

.ant-table-filter-dropdown {
  background-color: #213338;
}
.ant-dropdown-menu {
  background-color: #213338;
}

.ant-dropdown-menu-item {
  color: white;
}

.ant-dropdown-menu-item:hover {
  background-color: #163d4a;
}

.ant-dropdown-menu-item-selected {
  background-color: #163d4a;
}

.ant-dropdown-menu-item.ant-dropdown-menu-item-active {
  background-color: #163d4a;
}

.ant-dropdown-menu-item.disabled {
  color: rgba(255, 255, 255, .3);
  cursor: not-allowed;
}
  
.container {
  position: relative;
  margin-top: 32px
}

.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab:not(:last-of-type), .ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab:not(:last-of-type), .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab:not(:last-of-type), .ant-tabs-card.ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-tab:not(:last-of-type) {
  height: 32px;
  margin-right: 16px;
}

.explore_container {
  position: relative;
  margin-top: 8px
}

.ant-empty-description {
  color: rgba(255, 255, 255, .95);
}
  
.ant-pagination-prev button,
.ant-pagination-next button {
  font-family: TT Hoves;
  border: 1px solid #213338;
  border-radius: 4px;
  background-color: #182a30;
}

.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  background-color: #182a30;
  border: 1px solid #213338;
  border-radius: 4px;
  color: #afc1c7;
}

.ant-pagination-item,
.ant-pagination-prev,
.ant-pagination-next {
  font-family: TT Hoves;
  border: 1px solid #485558;
  border-radius: 4px;
  background-color: #182a30;
}

.ant-pagination-item a {
  color: #afc1c7;
}

#explore > div > div > div > div.ant-form-item-explain.ant-form-item-explain-error > div{
  text-align: left;
  margin-left: 16px;
}

.ant-pagination-item-active a {
  color: rgba(204, 212, 217, 1);
}
.ant-pagination-item-active {
  font-weight: 500;
  border: 1px solid #afc1c7d9;
}

.ant-form-item-has-error .ant-form-item-explain{
  text-align: left;
}

.ant-checkbox-disabled + span {
  color: rgba(255, 255, 255, 0.35);
}

#logical_expression_form .ant-select-selection-overflow-item {
  max-width: 11rem
}

.ant-select-single:not(.ant-select-customize-input) .ant-select-selector{
  background-color: #1C3138;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  text-align: left;
}

.ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector{
  background-color: #1C3138;
}

.ant-select-multiple .ant-select-selector, .ant-select-multiple .ant-select-selection-item{
  background-color: #1C3138; 
  border-radius: 4px;
  text-align: left;
}

.ant-select-clear, .ant-select-clear:hover{
  background-color: #213338;
  color: #afc1c7;
}

.ant-select-selection-search{
  width: unset !important;
}
  
.threat_ranking_text {
  text-align: left;
  margin-top: 32px;
  margin-bottom: 31px;
  margin-left: 10px;
  font-family: TT Hoves;
  font-style: normal;
  font-weight: 500;
  font-size: 30px;
  line-height: 35px;
  color: #afc1c7;
  vertical-align: middle;
}

.threatRankingBackButton {
  /* position is static by default */
  max-width: max-content;
  margin-top: 8px;
  margin-bottom: 4px;
  text-align: left;
  cursor: pointer;
}

.nav {
  position: absolute;
  left: 0px;
  width: 200px;
  background-color: #213338;
  border-radius: 5px;
  color: #afc1c7;
}

.feedIndicators {
  /* position is static by default */
  overflow: hidden;
  color: #afc1c7;
  margin-left: 220px;
  margin-bottom: 20px;
  background-color: #213338;
  border-radius: 5px;
  position: relative;
}

.feedIndicators > .feedIndicatorsBigNumber {
  position: absolute;
  left: 5%;
  margin-left: 1%;
  top: 30%;
  font-family: TT Hoves;
  font-style: normal;
  font-weight: 600;
  font-size: 60px;
}
  
.secondaryIndicators {
  /* position is static by default */
  color: #afc1c7;
  margin-left: 220px;
  margin-bottom: 20px;
  background-color: #213338;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}

.secondaryIndicators > .secondaryIndicatorsBigNumber {
  position: absolute;
  left: 5%;
  margin-left: 1%;
  top: 35%;
  font-family: TT Hoves;
  font-style: normal;
  font-weight: 600;
  font-size: 60px;
}

.customIndicators {
  /* position is static by default */
  color: #afc1c7;
  margin-left: 220px;
  margin-bottom: 20px;
  background-color: #213338;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}

.customIndicators > .customIndicatorsBigNumber {
  position: absolute;
  left: 5%;
  top: 10%;
  margin-left: 1%;
  font-family: TT Hoves;
  font-style: normal;
  font-weight: 600;
  font-size: 60px;

  color: #0aea7f;
}
  
  #left,
  #right {
    width: 40%;
    margin: 5px;
    padding: 1em;
    font-family: TT Hoves;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: rgba(175, 193, 199, 0.85);
  }
  
  #left {
    position: relative;
    float: left;
    left: 50px;
  }
  #right {
    float: right;
  }
  
  .nav_threat_total_score_logoContainer {
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
    width: 200px;
    height: 145px;
    left: 0px;
    top: 0px;
    border-radius: 5px;
  }
  
  .nav_threat_total_score_inside {
  }
  
  .nav_threat_total_score_text {
    position: absolute;
    left: 20%;
    top: 20%;
    font-family: TT Hoves;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    line-height: 50%;
  
    color: #ffffff;
  }
  
  .nav_threat_total_score_number {
    position: absolute;
    left: 50%;
    font-family: TT Hoves;
    font-style: normal;
    font-weight: 600;
    font-size: 60px;
  
    color: #ffffff;
  }
  
  .navbar_text_elements {
    margin-bottom: 15%;
    word-wrap: break-word;
  }
  
  .navbar_label {

    line-height: 100%;
    font-family: TT Hoves;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.65);
  }

  

  .navbar_text {
    line-height: 100%;
    font-family: TT Hoves;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    
    color: #ffffff;
  }
  
  .login-form {
    max-width: 30%;
    margin: 150px auto;
  }
  
  .ant-input-clear-icon{
    color: #afc1c7
  }

  .ant-input-clear-icon:hover{
    color: #afc1c7
  }

  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected{
    background: transparent
  }

  .ant-menu-inline.ant-menu-root .ant-menu-item{
    height: 36px;
    align-items: center;
  }

  .ant-menu.ant-menu-dark .ant-menu-sub {
    background: #0C171B;
  }

  .ant-layout-sider-dark {
    background: #15262B;
  }

  .ant-breadcrumb-link, .ant-breadcrumb a, .ant-breadcrumb > span:last-child a{
    color: #afc1c7
  }

  .ant-breadcrumb-separator{
    color: #afc1c7
  }

  .ant-input-affix-wrapper > input.ant-input {
    background-color: #213338 !important;
  }
  
  .ant-input-affix-wrapper {
    background-color: #213338 !important;
    border-color: rgba(255, 255, 255, 0.2);
  }
  
  .ant-input {
    color: rgba(255,255,255,0.85);
    border: 1px solid rgba(255,255,255,0.2);
    background-color: #213338;
    border-radius: 4px;
  }
  
  .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input, .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover{
    background-color: #213338;
  }

  .ant-input-password .ant-input-password-icon  {
    color: #b1c4d0;
  }
    
  .ant-form-item-has-error .ant-input[disabled] {
    border-color: #ff4d4f;
  }

  .ant-input-group-addon {
    background: #213338;
  }
  .ant-input-group-addon button {
    color: rgba(255, 255, 255, .3) !important;
    border-color: rgba(255, 255, 255, .2) !important;
  }

  .ant-form-item-has-error .ant-select:not(.ant-select-disabled):not(.ant-select-customize-input) .ant-select-selector {
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  background-color: transparent;
  }

  .ant-input[disabled] {
    background: #213338;
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  .ant-checkbox-inner,
  .ant-radio-inner {
    background: transparent;
  }

  .ant-radio-group {
    label {
      background: none !important;
    }
    .ant-radio-button-wrapper:not(.ant-radio-button-wrapper-checked) {
      border: 1px solid rgba(255,255,255,0.2);
    }
    .ant-radio-button-wrapper-checked {
      border: 1px solid #1890ff;
    }
    .ant-radio-button-wrapper-disabled {
      color: rgba(255, 255, 255, 0.3);
    }
  }
  
  .ant-select-arrow {
    color: rgba(175, 193, 199, 0.85);
  }

  .indicator_bar_and_text_container {
    position: relative;
    height: 30px;
  }
  
  .indicator_text {
    position: absolute;
    top: 6px;
    left: 20%;

    @media (max-width: 1440px) {
      left: 15%;
    }
  }
  
  .indicator_progressbar {
    position: absolute;
    top: 15px;
    left: 45%;
    width: 120%;
  }
  
  .navbar_label_and_progressbar_container {
    position: relative;
    text-align: left
    margin-bottom: 10px;

    @media (max-width: 1440px) {
      margin-bottom: 25px;
    }
  }

  .navbar_label_and_progressbar_container_not_collapsed {
    position: relative;
    text-align: left
    margin-bottom: 10px;
    @media (max-width: 1641px) {
      margin-bottom: 50px;
    }
  }

  .navbar_progressbar {
    position: absolute;
    top: 75%;
    width: 70%;
    left: 60%;
  }
  
  /*preferences*/
  /*preferences tabs*/
  
  .ant-tabs-tabpane {
    color: #fff;
    background: #1C3138;
  }
  
  .ant-tabs {
    background: #16262B;
    color: #fff;
    
  }


  .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab{
    border: none;
    webkit-transition: none;
    transition: none;
  }
  
  .ant-tabs-tab.ant-tabs-tab-active{
   background: #28373C !important;
   border-bottom: 2px solid #65B7F3 !important;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{
    color: #65B7F3;
    
  }

  .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab-active{
    border-radius: 4px 4px 0px 0px;
  }

  .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
    background: #16262B;
  }
  
  .ant-tabs-top > .ant-tabs-nav{
    margin: 0
  }
  
  .ant-tabs-top > .ant-tabs-nav::before,
  .ant-tabs-bottom > .ant-tabs-nav::before,
  .ant-tabs-top > div > .ant-tabs-nav::before,
  .ant-tabs-bottom > div > .ant-tabs-nav::before {
    border: none;
  }
  
  .tab_item {
    margin-bottom: 5px;
  }
  
  .tab_item_label {
    margin-right: 5px;
  }
  
  .tab_switch {
    margin-left: 5px;
  }
  
  .tab_save {
    margin-right: 5px;
  }
  
  .tab_button_container {
    margin-top: 15px;
    margin-bottom: 10px;
  }
  
  .ant-select-selector {
    color: rgba(255, 255, 255, 0.85);
    background-color: #1C3138;
    border: 1px solid rgba(255,255,255,0.2);
    
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector{
    background-color: #1C3138;
    border: 1px solid rgba(255,255,255,0.2);
  }


  .ant-select-selection-placeholder{
    opacity: 0.65
  }
  
  .ant-select-disabled.ant-select-single:not(.ant-select-customize-input) .ant-select-selector,
  .ant-form-item-has-error .ant-select:not(.ant-select-borderless) .ant-select-selector,
  .ant-form-item-has-error .ant-input-number, .ant-form-item-has-error .ant-picker {
    color: rgba(255, 255, 255, 0.85);
    background: #1C3138;
    border-radius: 4px;
  }

  .ant-picker {
    background: #1C3138;
    color: rgba(255, 255, 255, 0.85);
    border: 1px solid rgba(255,255,255,0.2);
  }
  
  .ant-picker-suffix {
    background: #1C3138;
    color: #b1c4d0;
  }
  
  .ant-picker-clear {
    background: #213338;
    color: rgba(255, 255, 255, 0.85) !important;
  }
  
  .ant-picker-input > input {
    color: rgba(255, 255, 255, 0.85);
    background: #1C3138;
  }
  
.iconClass > path {
  fill: 'white';
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.ant-picker-panel-container {
  background: #213338;
}

.ant-picker-content th {
  color: #b1c4d0;
}

.ant-picker-header-view button {
  color: #b1c4d0;
}

.ant-picker-header button {
  color: #b1c4d0;
}

.ant-switch-checked {
  
}

.ant-menu-vertical{
border: none;
}

.ant-modal {
  color: #b1c4d0;
}

.ant-modal-content,
.ant-modal-header {
  background: #213338;
}

.ant-modal-content {
  border-radius: 1rem;
  overflow: hidden;
  padding: 1rem;
}

.ant-modal-header, .ant-modal-footer {
  border: none;
}

.ant-modal-header {
  padding: 1.5rem 1.5rem 3rem;
}
.ant-modal-body {
  padding: 0 1.5rem;
}
.ant-modal-footer {
  padding: 1.5rem;
  text-align: center;
}

.ant-modal-title {
  font-size: 150%;
  text-align: center;
  line-height: 27px;
}

.ant-modal-confirm-body .ant-modal-confirm-title,
.ant-modal-title {
  color: white;
  font-weight: bold;
}

.modal_radio_button {
  display: block;
  height: 30px;
  line-height: 30px;
  color: #b1c4d0;
}

.ant-input-number {
  color: rgba(255, 255, 255, 0.85);
  background: #213338 !important;
  border: 1px solid rgba(255,255,255,0.2);
  border-right-width: 1px;
  border-radius: 4px;
}

.ant-input-number-handler-wrap {
  display: none;
  border-radius: 4px;
}

.export_button_container {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 15px;
  margin-bottom: 10px;
}

.ant-select-dropdown {
  color: #b1c4d0;
  background: #213338;
}

.ant-select-item {
  color: rgba(255, 255, 255, 0.85);
}

.ant-select-item-option-active:not(.ant-select-item-option-disabled){
  background: #163d4a;
  color: #b1c4d0;
}

.ant-select-item-option-selected:not(.ant-select-item-option-disabled),
.ant-select-item-option:hover,
.ant-select-item-option:active,
.ant-select-item-option:focus {
  background: #163d4a;
  color: #b1c4d0;
}

.export_complexity_switch {
  margin-bottom: 10px;
}

.ant-pagination-jump-prev
  .ant-pagination-item-container
  .ant-pagination-item-ellipsis,
.ant-pagination-jump-next
  .ant-pagination-item-container
  .ant-pagination-item-ellipsis {
  color: #afc1c7;
}

.ant-form-item-label > label {
  color: #afc1c7;
}
.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
  font-size: 20px;
}

.ant-popover {
  max-width: 60%;
}
#andvancedFilterPopover {
  max-width: 70%;
}

.ant-popover-inner-content{
  background-color: #213338;
  color: rgba(255, 255, 255, 0.95);
}

.ant-drawer-content{
  background-color: #b1c4d0;
}

.ant-drawer-header{
  background-color: #b1c4d0;
  border-bottom: none;
}

.ant-select-selection-placeholder {
  text-align: left;
}

.ant-menu-vertical > .ant-menu-item {
  height: 32px;
  line-height: 32px;
}

.funnel_icon{
  font-size: 30px;
  color: #afc1c7;
  position: absolute;
  left: 100px;
  top: 217px;

  @media (max-width: 1025px) {
    top: 100px;
    left: 290px;
  }
}

.funnel_icon.blue {
  color: #1890ff;
}

.anticon-user{
  color: #afc1c7;
}

.anticon-lock{
  color: #afc1c7;
}

.anticon-close{
  color: #afc1c7;
}

.anticon-info-circle {
  color: #d2d2d2;
  &:hover {
    cursor: pointer;
    color: #3C9AE8;
  }
}

.ant-picker-clear{
  color: #182a30;
}

.ant-form label{
  color: #fff;
}

.explore_navigate_popover{
  cursor: pointer;
}

.ant-cascader-picker-label{
  text-align: left;
}

.ant-cascader-picker-clear{
  background-color: transparent;
  color: #b1c4d0;
}

.ant-cascader-picker-clear:hover{
  background-color: transparent;
  color: #b1c4d0;
}

.ant-timeline.ant-timeline-alternate .ant-timeline-item-head{
  margin-left: -7px;
}

.ant-timeline-item-tail{
  border-left: 1px solid rgba(255, 255, 255, 0.65);
}

.ant-timeline-item-head-blue{
  color: rgba(232, 154, 60, 1);
  border-color: rgba(232, 154, 60, 1);
}
.ant-timeline-item-head{
  width: 16px;
  height: 16px;
  background: rgba(232, 154, 60, 1);
}

.ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon, .ant-cascader-menu-item-loading-icon{
  color: #b1c4d0;
}

.ant-cascader-input{
  background-color: #213338;
  color: #b1c4d0;
  border-radius: 4px;
}

.ant-cascader-picker-arrow{
  color: #b1c4d0;
}

.ant-cascader-menu{
  border: none;
  height: 298px;
}

.ant-cascader-menus{
  background-color: #182a30;
  color: #b1c4d0; 
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar {
  height: 5px;
  width: 5px;
}

::-webkit-scrollbar-corner {
  background: rgb(22, 38, 43);
}

::-webkit-scrollbar-thumb
{
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #555;
}

.ant-form-item-control-input-content{
  flex: none;
}

.ant-form-item-control-input{
  display: block;
}

.ant-upload{
  color: #F3F4F4;
}

.ant-upload-list-item-card-actions .anticon{
  color: white;
}

.ant-upload-list-item-name {
  padding: 0 !important;
}

.ant-upload-list-item-card-actions-btn {
  opacity: 100;
}

.ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled), .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled):hover{
  background-color: #163d4a
}

.ant-cascader-menu-item:hover{
  background-color: #163d4a
}

.ant-cascader-picker-show-search.ant-cascader-picker-focused{
  color: #b1c4d0;
}

.ant-select-multiple .ant-select-selector{
  border: 1px solid rgba(255,255,255,0.2);
}

.ant-form-item-has-error .ant-input:not(.ant-form-item-has-error .ant-input-disabled){
  background-color: transparent;
}

.ant-form-item-has-error .ant-input:not(.ant-form-item-has-error .ant-input-disabled):hover{
  background-color: transparent;
}

.playbook_new_button{
  position: absolute
  right: 0px
}

.ant-picker.ant-picker-disabled{
  background: #213338 !important;
  color: #213338 !important;
  border: 1px solid rgba(255,255,255,0.2) !important;
}

.ant-picker-input > input[disabled]{
  color: #213338 !important;
}

.ant-picker-header-view{
  color: #b1c4d0;
}

.ant-picker-time-panel-column > li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner{
  color: #b1c4d0;
}

.ant-picker-time-panel-column > li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner{
  color: #163d4a;
}

.ant-picker-cell {
  color: rgba(255, 255, 255, .6);
}

.ant-picker-cell-disabled::before {
  background: #354450 !important;
}

.ant-picker-cell-disabled {
  color: rgba(255, 255, 255, .3) !important;
}

.ant-picker-cell-in-view {
  color: rgba(255, 255, 255, .95);
}
.ant-picker-cell-in-view:hover .ant-picker-cell-inner, .ant-picker-cell-inner:hover {
  background: #3c9ae8 !important;
}

.expandedRow{
  background-color: #213338 !important;
}

span.ant-typography {
  color: #b1c4d0;
}

.ant-tooltip-inner .ant-typography {
  color: #fff;
}

.ant-typography {
  color: rgba(255, 255, 255, 0.95);
}

a.ant-typography, .ant-typography a {
  color: #3B98E6;
}

a.ant-typography:hover, .ant-typography a:hover {
  color: #40a9ff;
}

.highlightCondition {
  border: 1px solid #3C9AE8 !important;
  background-color: #1C394C !important;
}

/* ------ TABLE CLASSES ------ */

.ant-table {
  background-color: #15262B;
  color: #b1c4d0;
  border: 1px solid hsla(0,0%,100%,.3);
  overflow-x: scroll;
  transition: all ease-in-out .3s;
}

.highlightEnrichmentTable .ant-table {
  border-color: #3B98E6;
  box-shadow: 0 0 20px rgba(0, 0, 0, .4);
}

.ant-table-tbody > tr > td {
  height: 40px;
  padding: 0;
  border-top: 1px solid hsla(0,0%,100%,.3);
  border-bottom: none;
  background: transparent !important;
  word-break: break-word;
}

.ant-table-tbody > tr > td.ant-table-cell-row-hover {
  background-color: #153d4a !important;
  background: #153d4a !important;
}

td.ant-table-column-sort {
  background: transparent;
}

.ant-table-thead > tr > th {
  background: #122025;
  border: none;
  padding: 10px 15px;
}

.ant-table-title {
  padding: 0;
}

.ant-table-thead th.ant-table-column-sort {
  background: #122025;
}

.table-row-hidden {
  display: none !important
}
.table-row-show {
  display: table-row
}

.ant-table-tbody tr:nth-child(even) {
  background-color: #1A2D33;
}

.ant-table-filter-column {
  line-height: 1.3
}

.ant-table-footer {
  padding: 10px 15px;
  font-weight: bold;
  background-color: #1A2F3A;
  color: rgba(255, 255, 255, 0.85);
  border-top: 1px solid hsla(0,0%,100%,.3);
}

.ant-column-white {
  color: rgba(255, 255, 255, .95);
  font-weight: 600;
}
.ant-column-white > :not(button span) {
  color: rgba(255, 255, 255, .95);
}

/* --- EXCEPTIONS --- */

.dns_table .ant-table-title {
  color: rgba(255, 255, 255, 0.85);
  font-weight: bold;
  padding: 10px 15px;
  background-color: #122025;
}

/* --- EXCEPTIONS END --- */
/* ------ TABLE CLASSES END ------ */


/* ------ COLLAPSE CLASSES ------ */

.ant-collapse {
  background-color: transparent;
  border: none;
}
.ant-collapse-content {
  background-color: transparent;
  border: none;
}
.ant-collapse-item {
  border: none !important;
}
.ant-collapse-expand-icon {
  color: rgba(255, 255, 255, 0.95);
}
.ant-collapse-expand-icon span {
  font-size: 1.3rem !important;
}
.ant-table-row-expand-icon {
  background: transparent;
}
.ant-table-expanded-row {
  background: #153D4A;
}
.expanded {
  transform: rotate(90deg);
}

/* --- EXCEPTIONS --- */

.ant-affix {
  z-index: 100;
}
.collapse_row .ant-collapse-header {
  padding: 6px 0 6px 0 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.collapse_row .ant-collapse-header:hover {
  background-color: #1A2D33;
}
.collapse_row .ant-collapse-content-box {
  padding: 1rem 0 0;
}

.collapse_row_recipe .ant-collapse-header {
  padding: 6px 0 6px 0 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.collapse_row_recipe .ant-collapse-header:hover {
  background-color: #1A2D33;
}
.collapse_row_recipe .ant-collapse-content-box {
  padding: 0 0 0;
}


/* --- EXCEPTIONS END --- */
/* ------ COLLAPSE CLASSES END ------ */

/* --- SPACING CLASSES --- */
.m-0 {
  margin: 0 !important;
}
.p-0 {
  padding: 0 !important;
}
.pt-05 {
  padding-top: .5rem !important;
}
.mt-0 {
  margin-top: 0 !important;
}
.mt-05 {
  margin-top: .5rem;
}
.mt-1 {
  margin-top: 1rem;
}
.mb-1 {
  margin-bottom: 1rem;
}
.ms-1 {
  margin-left: 1rem;
}
.ms-05 {
  margin-left: .5rem;
}
.me-1 {
  margin-right: 1rem;
}
.me-05 {
  margin-right: .5rem;
}
/* --- SPACING CLASSES END --- */

/* --- BUTTON CLASSES --- */

.ant-btn[disabled], .ant-btn[disabled]:hover, .ant-btn[disabled]:focus, .ant-btn[disabled]:active {
  background: transparent;
  color: #595959 !important;
  border: none;
}

.ant-btn.ant-btn-primary[disabled] {
  background: #434343;
  color: #595959 !important;
}

.ant-btn.ant-btn-default {
  border-radius: 4px;
  color: #3B98E6;
  border-color: #3B98E6;
}

.ant-btn:hover,
.ant-btn:active,
.ant-btn:focus {
  border: 1px solid #1765AD;
  background: transparent;
}

.ant-btn-primary {
  background: #3C9AE8;
  color: #FFFFFF;
  box-shadow: 0px 1px 2px rgba(97, 97, 97, 0.2), 0px 2px 4px rgba(97, 97, 97, 0.2);
  border-radius: 4px;
}

.ant-btn.ant-btn-primary:focus,
.ant-btn.ant-btn-primary:active,
.ant-btn.ant-btn-primary:hover {
  background: #1765AD; 
}

.ant-btn-link {
  color: #3B98E6;
}
.ant-btn-link:hover {
  border-color: #3B98E6;
}

.ant-btn-ghost {
  color: rgba(255, 255, 255, 0.95);
  background-color: rgb(46, 65, 72);
  border: none !important;
  border-radius: 4px;
}
.ant-btn-ghost:hover {
  background-color: #1E3641;
  color: rgba(255, 255, 255, 0.95);
}

.ant-btn-text {
  color: #3C9AE8 !important;
  background: none;
  border: none !important;
}
.ant-btn-text:hover {
  color: #1565AD !important;
}

.ant-btn-dangerous.ant-btn-link:hover {
  border-color: #E84749;
}
.ant-btn-dangerous.ant-btn-primary {
  background: #E84749;
  border-color: #E84749;
}
.ant-btn-dangerous.ant-btn-primary:active,
.ant-btn-dangerous.ant-btn-primary:hover,
.ant-btn-dangerous.ant-btn-primary:focus {
  background: #E84749;
  border-color: #E84749;
}
.ant-btn-dangerous.ant-btn-default {
  border-color: #E84749;
  color: #E84749;
}
.ant-btn.ant-btn-default, .ant-btn.ant-btn-default:hover, .ant-btn.ant-btn-default:active, .ant-btn.ant-btn-default:focus {
  opacity: 1 !important;
  background: transparent;
}

.ant-btn-icon-only.ant-btn-sm {
  border: none;
}
.ant-btn[disabled], .ant-btn[disabled]:hover, .ant-btn[disabled]:focus, .ant-btn[disabled]:active{
  background: #213338;
}

.ant-menu-inline.ant-menu-root .ant-menu-item > .ant-menu-title-content{
  width: 100%;
  height: 100%;
  overflow: visible;
}

.ant-popover-arrow-content {
  --antd-arrow-background-color: black;
}

/* --- BUTTON CLASSES END --- */
`;
